import {
  Credentials,
  AuthenticationService
} from './../authentication/authentication.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { environment } from '@env/environment';
import { Const } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  // Contiene las rutas de excecion para enviar o validar el token
  routesExepcion: Array<string> = [
    Const.ROUTES_SYSTEM_INTEGRATIONS.cita.index,
    this.api.get('login'),
    this.api.get('refresToken'),
    this.api.get('externalBulletin'),
    this.api.get('externalPublication'),
    this.api.get('downloadDocumentPublication')
  ];

  constructor(
    private lss: LocalStorageService,
    private as: AuthenticationService,
    private toastr: ToastrService,
    private api: EndpointService,
    private sss: SessionStorageService,
  ) { }

  /**
   * Funcion que interceta las peticiones http y agrega el token del usuario autenticado
   * Nota: para las peticiones http dirigidas a la integracion con CITA 1 este token se ignora
   *
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   * @memberof AuthInterceptor
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const search = this.routesExepcion.indexOf(req.url);
    if (search === -1) {
      let authToken: Credentials;
      // Get the auth header from your auth service.
      const credentialsL: Credentials = this.lss.retrieve(environment.credentialsKey);

      if (credentialsL) {
        authToken = credentialsL;
      } else {
        authToken = this.sss.retrieve(environment.credentialsKey);
      }

      let authReq: any;
      if (authToken) {
        if (this.as.isAuthenticated()) {
          if (this.validRefresh(this.as.getTokenExpirationDate(authToken.token))) {
            this.as.refreshToken(authToken.token).subscribe(data => {
              authReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${data.token}`) });
              return next.handle(authReq);
            });
          } else {
            authReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${authToken.token}`) });
            return next.handle(authReq);
          }
        } else {
          this.logout();
          return;
        }
      } else {
        authReq = req.clone({ headers: req.headers.set('Authorization', ``) });
        return next.handle(authReq);
      }
    }
    return next.handle(req);
  }

  /**
   * Se encarga de cerrar la sesión del token expirado y redirecionarlo a el login
   *
   * @memberof AuthInterceptor
   */
  logout() {
    this.toastr.warning(
      'Debido a el tiempo de inhabilidad en el sistema la sesión ha sido expirada',
      'Sesión expirada'
    );
    this.as.logout();
    location.reload();
  }

  /**
   * calcula la diferencia en milisegundos de la fecha de expiracion del token con la actual
   * e indica si es hora de actualizar el token si la diferencia es menor a 30 segundos
   *
   * @param {Date} dateTokenExpired
   * @returns {boolean}
   * @memberof AuthInterceptor
   */
  validRefresh(dateTokenExpired: Date): boolean {
    const moment = require('moment');
    const dateToken = moment(dateTokenExpired);
    const date = moment();
    const timeExpired = dateToken.diff(date);
    if (timeExpired < 30000) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/http/auth.interceptor.ts